export class VehicleTypeReferenceModel {
    public vehicleTypeCode: string;
    public vehicleGroupCode: string;
    public vehicleTypeName: string;
    public sortSequence: number;
}